import PropTypes from "prop-types";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import title from "../../../assets/admin/title.svg";
import sidebar_dashboard from "../../../assets/admin/sidebar_dashboard.svg";
import sidebar_restaurant from "../../../assets/admin/sidebar_restaurant.svg";
import sidebar_stock_management from "../../../assets/restaurant/stock_management.svg";
import sidebar_usersettings from "../../../assets/admin/sidebar_usersettings.svg";
import sidebar_greetingcard from "../../../assets/restaurant/greeting-card.svg";
import sidebar_addUser from "../../../assets/admin/sidebar_add-user.svg";
import sidebar_settings from "../../../assets/admin/sidebar_settings.svg";
import { MdCancel } from "react-icons/md";
import { IoIosArrowForward } from "react-icons/io";
import { toast } from "react-toastify";
import { TbLogout2 } from "react-icons/tb";
import { CgLogOut } from "react-icons/cg";

import axios from "axios";

const RestSidebar = ((props, ref) => {
  const {
    closeModal,
    showSidebarForMobile,
    setShowSidebarForMobile,
    hasPermission
  } = props;

  const location = useLocation();
  const navigate = useNavigate();
  const sidebarRef = useRef();
  const pathname = location.pathname;

  // Constants
  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const userId = localStorage.getItem("loginUserId") ?? "null";
  const restId = localStorage.getItem("currentRestId") ?? "null";
  const token = localStorage.getItem("token");

  // State management
  const [selectedRadio, setSelectedRadio] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);

  // Handlers
  const toggleDropdown = (path) => {
    setOpenDropdown(openDropdown === path ? null : path);
  };

  const handleRadioChange = (e, radioName, route) => {
    e.stopPropagation();
    if (route) {
      navigate(route);
    }
    const validRadioNames = [
      "ViewStock",
      "StockManagement",
      "IncomingOrder",
      // "PastOrder",
      "RestaurantUser",
      "RestaurantUserAdd",
      "DishManagement",
      "CourseManagement",
      "MenuManagement",
      "WineFood",
      "BeverageManagement",
      "CategoryManagement",
      "Profile",
      "ProfileDetail",
      "ChangePassword",
    ];
    if (validRadioNames.includes(radioName)) {
      setSelectedRadio(radioName);
    }
  };

  const userLogout = async () => {
    try {
      const response = await axios.post(
        `${apiUrl}/api/v1/logout`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        clearLocalStorage();
        toast.success(response?.data?.message, { theme: "colored", autoClose: 1000 });
        navigate("/restaurantPanel/login");
      }
    } catch (err) {
      if (err.response?.status === 401) {
        clearLocalStorage();
        toast.success(err?.response?.data?.message, { theme: "colored", autoClose: 1000 });
        navigate("/restaurantPanel/login");
      }
    }
  };

  const clearLocalStorage = () => {
    ["Role", "token", "currentRestId", "loginUserId", "type", "RoleName", "RoleId"].forEach(
      key => localStorage.removeItem(key)
    );
  };

  const redirectToAdmin = () => {
    localStorage.removeItem('currentRestId');
    localStorage.removeItem('accessToAdmin');
    navigate(`/admin/dashboard`);
  };


  //Defined Routes
  const mainItems = [
    // Route For Dashboard Page
    {
      path: hasPermission("Dashboard", "view") && `/restaurantPanel/dashboard/${restId}`,
      label: "Dashboard",
      icon: sidebar_dashboard,
      isDropdown: false,
      isPermission: hasPermission("Dashboard", "view")
    },
    // Routes For Gestione Cantina Page And It's Dropdown Menu
    {
      path: hasPermission("WineStock", "view") ?
        `/restaurantPanel/viewStock/${restId}` :
        `/restaurantPanel/decreaseStock/${restId}`,
      label: "Gestione Cantina",
      icon: sidebar_stock_management,
      isDropdown: true,
      isPermission: hasPermission("WineStock", "view") || hasPermission("WineStock", "add") || hasPermission("WineStock", "remove"),
      dropdownContent: (
        <div className="m-1 pt-3 pb-3 space-y-4">
          {hasPermission("WineStock", "view") && <label className="flex items-center justify-between border-[#983D4A] pb-3 border-b gap-2">
            <span className="block w-[100px] cursor-pointer">Visualizza Giacenze</span>
            <input
              type="radio"
              className="custom-checkbox"
              name="restaurantOptions"
              checked={selectedRadio === "ViewStock"}
              onChange={(e) => handleRadioChange(e, "ViewStock", `/restaurantPanel/viewStock/${restId}`)}
            />
          </label>}
          {(hasPermission("WineStock", "add") || hasPermission("WineStock", "remove")) && <label className="flex items-center justify-between">
            <span className="cursor-pointer">Gestisci Giacenze</span>
            <input
              type="radio"
              className="custom-checkbox"
              name="restaurantOptions"
              checked={selectedRadio === "StockManagement"}
              onChange={(e) => handleRadioChange(e, "StockManagement", `/restaurantPanel/decreaseStock/${restId}`)}
            />
          </label>}
        </div>
      ),
    },
    // Routes For I miel Ordini Page And It's Dropdown Menu
    {
      path: `/restaurantPanel/incomingOrder/${restId}`,
      label: "I miei Ordini",
      icon: sidebar_restaurant,
      isDropdown: true,
      isPermission: hasPermission("Orders", "view"),
      dropdownContent: (
        <div className="m-1 pt-3 pb-3 space-y-4">
          <label className="flex items-center justify-between border-[#983D4A] gap-2">
            <span className="cursor-pointer">
              <Link to={`/restaurantPanel/incomingOrder/${restId}`} onClick={(e) => {
                e.stopPropagation();
                closeModal();
              }}>Ordini In Entrata</Link>
            </span>
            <input
              type="radio"
              className="custom-checkbox"
              name="restaurantOptions"
              checked={selectedRadio === "IncomingOrder"}
              onChange={(e) => handleRadioChange(e, "IncomingOrder", `/restaurantPanel/incomingOrder/${restId}`)}
            />
          </label>
          {/* <label className="flex items-center justify-between">
            <span className="cursor-pointer">
              <Link to={`/restaurantPanel/pastOrder/${restId}`} onClick={(e) => {
                e.stopPropagation();
                closeModal();
              }}>Ordini Passati</Link></span>
            <input
              type="radio"
              className="custom-checkbox"
              name="restaurantOptions"
              checked={selectedRadio === "PastOrder"}
              onChange={(e) => handleRadioChange(e, "PastOrder", `/restaurantPanel/pastOrder/${restId}`)}
            />
          </label> */}
        </div>
      ),
    },
    // Route For Gestisci Carte Vino Page
    {
      path: `/restaurantPanel/restaurantManagement/${restId}`,
      label: "Gestisci Carte Vino",
      icon: sidebar_greetingcard,
      isDropdown: false,
      isPermission: hasPermission("WineList", "view"),
    },
    //Route For Menu Management Page
    {
      path: `/restaurantPanel/menuManagement/${restId}`,
      label: "Gestisci Menu",
      icon: sidebar_stock_management,
      isDropdown: true,
      isPermission: true,
      dropdownContent: (
        <div className="m-1 pt-3 pb-3 space-y-4">
          <label className="flex items-center justify-between border-[#983D4A] pb-3 border-b gap-2">
            <span className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                closeModal();
              }}>
              Gestisci Piatti
            </span>
            <input
              type="radio"
              className="custom-checkbox"
              name="restaurantOptions"
              checked={selectedRadio === "DishManagement"}
              onChange={(e) => handleRadioChange(e, "DishManagement", `/restaurantPanel/dishManagement/${restId}`)}
            />
          </label>
          <label className="flex items-center justify-between border-[#983D4A] pb-3 border-b gap-2">
            <span className="cursor-pointer w-[100px]"
              onClick={(e) => {
                e.stopPropagation();
                closeModal();
              }}>
              Gestisci Portata
            </span>
            <input
              type="radio"
              className="custom-checkbox"
              name="restaurantOptions"
              checked={selectedRadio === "CourseManagement"}
              onChange={(e) => handleRadioChange(e, "CourseManagement", `/restaurantPanel/courseManagement/${restId}`)}
            />
          </label>
          <label className="flex items-center justify-between border-[#983D4A] pb-3 border-b gap-2">
            <span className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                closeModal();
              }}>
              Gestisci Menu
            </span>
            <input
              type="radio"
              className="custom-checkbox"
              name="restaurantOptions"
              checked={selectedRadio === "MenuManagement"}
              onChange={(e) => handleRadioChange(e, "MenuManagement", `/restaurantPanel/menuManagement/${restId}`)}
            />
          </label>
          <label className="flex items-center justify-between border-[#983D4A] pb-3 border-b gap-2">
            <span className="cursor-pointer w-[100px]"
              onClick={(e) => {
                e.stopPropagation();
                closeModal();
              }}>
              Abbinamento Vino-Piatti
            </span>
            <input
              type="radio"
              className="custom-checkbox"
              name="restaurantOptions"
              checked={selectedRadio === "WineFood"}
              onChange={(e) => handleRadioChange(e, "WineFood", `/restaurantPanel/wineFood/${restId}`)}
            />
          </label>
          <label className="flex items-center justify-between border-[#983D4A] pb-3 border-b gap-2">
            <span className="cursor-pointer w-[100px]"
              onClick={(e) => {
                e.stopPropagation();
                closeModal();
              }}>
              Gestisci Bevande
            </span>
            <input
              type="radio"
              className="custom-checkbox"
              name="restaurantOptions"
              checked={selectedRadio === "BeverageManagement"}
              onChange={(e) => handleRadioChange(e, "BeverageManagement", `/restaurantPanel/beverageManagement/${restId}`)}
            />
          </label>
          <label className="flex items-center justify-between border-[#983D4A] gap-2">
            <span className="cursor-pointer w-[100px]"
              onClick={(e) => {
                e.stopPropagation();
                closeModal();
              }}>
              Gestisci Categoria
            </span>
            <input
              type="radio"
              className="custom-checkbox"
              name="restaurantOptions"
              checked={selectedRadio === "CategoryManagement"}
              onChange={(e) => handleRadioChange(e, "CategoryManagement", `/restaurantPanel/categoryManagement/${restId}`)}
            />
          </label>
        </div>
      ),
    },
    // Routes For Ristoranti Utenti Page And It's Dropdown Menu
    {
      path: hasPermission("Users", "view") || hasPermission("Users", "view") ? `/restaurantPanel/restaurant-user/${restId}` : `/restaurantPanel/restaurant-user-add/${restId}`,
      label: "Utenti",
      icon: sidebar_usersettings,
      isDropdown: true,
      isPermission: hasPermission("Users", "view") || hasPermission("Users", "view"),
      dropdownContent: (
        <div className="m-1 pt-3 pb-3 space-y-4">
          {hasPermission("Users", "view") && <label className="flex items-center justify-between border-[#983D4A] pb-3 border-b gap-2">
            <span className="cursor-pointer">
              <Link to={`/restaurantPanel/restaurant-user/${restId}`}
                onClick={(e) => {
                  e.stopPropagation();
                  closeModal();
                }}>Lista Utenti</Link>
            </span>
            <input
              type="radio"
              className="custom-checkbox"
              name="restaurantOptions"
              checked={selectedRadio === "RestaurantUser"}
              onChange={(e) => handleRadioChange(e, "RestaurantUser", `/restaurantPanel/restaurant-user/${restId}`)}
            />
          </label>}

          {hasPermission("Users", "add") && <label className="flex items-center justify-between">
            <span className="cursor-pointer">
              <Link to={`/restaurantPanel/restaurant-user-add/${restId}`} onClick={(e) => {
                e.stopPropagation();
                closeModal();
              }}>Aggiungi Utenti</Link>
            </span>
            <input
              type="radio"
              className="custom-checkbox"
              name="restaurantOptions"
              checked={selectedRadio === "RestaurantUserAdd"}
              onChange={(e) => handleRadioChange(e, "RestaurantUserAdd", `/restaurantPanel/restaurant-user-add/${restId}`)}
            />
          </label>}
        </div>
      ),
    },
    {
      path: `/restaurantPanel/userRole/${restId}`,
      label: "Pannello Amministrazione",
      icon: sidebar_addUser,
      isDropdown: false,
      isPermission: hasPermission("Roles", "view"),
    },
  ];

  const settingsItems = [
    {
      path: `/restaurantPanel/settings/${restId}`,
      label: "Impostazioni",
      icon: sidebar_settings,
      isDropdown: true,
      isPermission: true,
      dropdownContent: (
        <div className="m-1 pt-3 pb-3 space-y-4">
          <label className="flex items-center justify-between pb-3 border-b border-[#983D4A]">
            <span className="w-[100px] cursor-pointer">
              <Link to={`/restaurantPanel/settings/${restId}`}
                onClick={(e) => {
                  e.stopPropagation();
                  closeModal();
                }}>
                Impostazioni del profilo
              </Link>
            </span>
            <input
              type="radio"
              className="custom-checkbox"
              name="userOptions"
              checked={selectedRadio === "Profile"}
              onChange={(e) => handleRadioChange(e, "Profile", `/restaurantPanel/settings/${restId}`)}
            />
          </label>
          {hasPermission("Restaurant_info", "view") &&
            <label className="flex items-center justify-between pb-3 border-b border-[#983D4A]">
              <span className="w-[100px] cursor-pointer">
                <Link to={`/restaurantPanel/settingsDetail/${restId}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    closeModal();
                  }}>
                  Informazioni del locale
                </Link>
              </span>
              <input
                type="radio"
                className="custom-checkbox"
                name="userOptions"
                checked={selectedRadio === "ProfileDetail"}
                onChange={(e) => handleRadioChange(e, "ProfileDetail", `/restaurantPanel/settingsDetail/${restId}`)}
              />
            </label>
          }
          <label className="flex items-center justify-between">
            <span className="w-[100px] cursor-pointer">
              <Link to={`/restaurantPanel/changePassword/${restId}`}
                onClick={(e) => {
                  e.stopPropagation();
                  closeModal();
                }}>
                Cambiare la password
              </Link>
            </span>
            <input
              type="radio"
              className="custom-checkbox"
              name="userOptions"
              checked={selectedRadio === "ChangePassword"}
              onChange={(e) => handleRadioChange(e, "ChangePassword", `/restaurantPanel/changePassword/${restId}`)}
            />
          </label>
        </div>
      ),
    },
  ];

  useImperativeHandle(ref, () => ({
    dropdown() {
      setOpenDropdown(null);
    },
  }));

  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showSidebarForMobile && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setShowSidebarForMobile(false);
      }
    };
    if (showSidebarForMobile) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showSidebarForMobile, setShowSidebarForMobile]);

  useEffect(() => {
    switch (true) {

      //Condition For Restaurant Dashboard Page
      case /^\/restaurantPanel\/dashboard(\/.*)?$/.test(pathname):
        break;

      //Condition For Restaurant ViewStock Page
      case /^\/restaurantPanel\/viewStock(\/.*)?$/.test(pathname):
        setSelectedRadio("ViewStock");
        setOpenDropdown(`/restaurantPanel/viewStock/${restId}`);
        break;
      //Condition For Restaurant DecreaseStock Page
      case /^\/restaurantPanel\/decreaseStock(\/.*)?$/.test(pathname):
        setSelectedRadio("StockManagement");
        setOpenDropdown(`/restaurantPanel/viewStock/${restId}`);
        break;

      //Condition For Restaurant IncomingOrder Page
      case /^\/restaurantPanel\/incomingOrder(\/.*)?$/.test(pathname):
        setSelectedRadio("IncomingOrder");
        setOpenDropdown(`/restaurantPanel/incomingOrder/${restId}`);
        break;
      //Condition For Restaurant PastOrder Page
      case /^\/restaurantPanel\/pastOrder(\/.*)?$/.test(pathname):
        setSelectedRadio("PastOrder");
        setOpenDropdown(`/restaurantPanel/incomingOrder/${restId}`);
        break;

      //Condition For Restaurant User Page
      case /^\/restaurantPanel\/restaurant-user(\/.*)?$/.test(pathname):
        setSelectedRadio("RestaurantUser");
        setOpenDropdown(`/restaurantPanel/restaurant-user/${restId}`);
        break;
      //Condition For Restaurant User Add Page
      case /^\/restaurantPanel\/restaurant-user-add(\/.*)?$/.test(pathname):
        setSelectedRadio("RestaurantUserAdd");
        setOpenDropdown(`/restaurantPanel/restaurant-user/${restId}`);
        break;

      //Condition For Restaurant RestaurantManagement Page
      case new RegExp(`^/restaurantPanel/restaurantManagement/${restId}`).test(pathname):
        break;

      //Condition For Restaurant MenuManagement Page
      case /^\/restaurantPanel\/menuManagement(\/.*)?$/.test(pathname):
        setSelectedRadio("MenuManagement");
        setOpenDropdown(`/restaurantPanel/menuManagement/${restId}`);
        break;
      //Condition For Restaurant wineFood Page
      case /^\/restaurantPanel\/wineFood(\/.*)?$/.test(pathname):
        setSelectedRadio("WineFood");
        setOpenDropdown(`/restaurantPanel/menuManagement/${restId}`);
        break;
      //Condition For Restaurant DishManagement Page
      case /^\/restaurantPanel\/dishManagement(\/.*)?$/.test(pathname):
        setSelectedRadio("DishManagement");
        setOpenDropdown(`/restaurantPanel/menuManagement/${restId}`);
        break;
      //Condition For Restaurant BeverageManagement Page
      case /^\/restaurantPanel\/beverageManagement(\/.*)?$/.test(pathname):
        setSelectedRadio("BeverageManagement");
        setOpenDropdown(`/restaurantPanel/menuManagement/${restId}`);
        break;
      //Condition For Restaurant CourseManagement Page
      case /^\/restaurantPanel\/courseManagement(\/.*)?$/.test(pathname):
        setSelectedRadio("CourseManagement");
        setOpenDropdown(`/restaurantPanel/menuManagement/${restId}`);
        break;
      //Condition For Restaurant CategoryManagement Page
      case /^\/restaurantPanel\/categoryManagement(\/.*)?$/.test(pathname):
        setSelectedRadio("CategoryManagement");
        setOpenDropdown(`/restaurantPanel/menuManagement/${restId}`);
        break;

      //Condition For Restaurant UserRole Page
      case new RegExp(`^/restaurantPanel/userRole/${restId}`).test(pathname):
        break;

      //Condition For Restaurant Settings Page
      case /^\/restaurantPanel\/settings(\/.*)?$/.test(pathname):
        setSelectedRadio("Profile");
        setOpenDropdown(`/restaurantPanel/settings/${restId}`);
        break;
      //Condition For Restaurant SettingsDetail Page
      case /^\/restaurantPanel\/settingsDetail(\/.*)?$/.test(pathname):
        setSelectedRadio("ProfileDetail");
        setOpenDropdown(`/restaurantPanel/settings/${restId}`);
        break;
      //Condition For Restaurant ChangePassword Page
      case /^\/restaurantPanel\/changePassword(\/.*)?$/.test(pathname):
        setSelectedRadio("ChangePassword");
        setOpenDropdown(`/restaurantPanel/settings/${restId}`);
        break;
      default:
        setOpenDropdown(null);
        break;
    }
  }, [pathname]);

  return (
    <>
      <div ref={sidebarRef} className={`lg:max-w-[250px] max-w-[200px] h-[100%] bg-[#F6EFEF] flex flex-col pt-4 rounded-3xl ${showSidebarForMobile ? "side-nav-bar-show" : "side-nav-bar"} px-5 relative`}>
        <MdCancel onClick={() => setShowSidebarForMobile(!showSidebarForMobile)} className="w-5 h-5 cancel-btn absolute top-3 right-3" color="gray" />
        <div className="text-center relative max-w-[150px] m-auto lg:p-0 px-4">
          <img src={title} className="m-4 ml-auto mr-auto w-full" height={50} width={150} />
          <div className="px-4 mt-2">
            <div className="items-center px-4 w-full h-[1px] bg-gray-300"></div>
          </div>
        </div>
        <nav className="flex flex-col flex-grow font-sans-serif items-center w-[171px] nav-side-bar">
          {mainItems?.map((route, index) => route?.isPermission && (
            <div
              key={index}
              className={`w-full py-1 px-4 items-center text-xs font-normal poppins-regular rounded-3xl my-2 group
              ${pathname === route?.path || (
                  (route.path.includes("dashboard") && /^\/restaurantPanel\/dashboard(\/.*)?$/.test(pathname)) ||
                  (route.path.includes("viewStock") && /^\/restaurantPanel\/(viewStock|decreaseStock)(\/.*)?$/.test(pathname)) ||
                  (route.path.includes("incomingOrder") && /^\/restaurantPanel\/(incomingOrder|pastOrder)(\/.*)?$/.test(pathname)) ||
                  (route.path.includes("restaurant-user") && /^\/restaurantPanel\/(restaurant-user|restaurant-user-add)(\/.*)?$/.test(pathname)) ||
                  (route.path.includes("restaurantManagement") && /^\/restaurantPanel\/restaurantManagement(\/.*)?$/.test(pathname)) ||
                  (route.path.includes("menuManagement") && /^\/restaurantPanel\/(menuManagement|wineFood|dishManagement|beverageManagement|courseManagement|categoryManagement)(\/.*)?$/.test(pathname)) ||
                  (route.path.includes("userRole") && /^\/restaurantPanel\/userRole(\/.*)?$/.test(pathname)) ||
                  (route.path.includes("settings") && /^\/restaurantPanel\/settings(\/.*)?$/.test(pathname))
                )
                  ? "text-[#FFFFFF] bg-[#8B2433]"
                  : "text-[#8B2433] bg-[#f7eeef] border-[1.5px] border-[#8B243385] hover:text-white hover:bg-[#8b2532]"
                }`}
            >
              <div className={`flex items-center cursor-pointer ${route?.isDropdown && openDropdown === route?.path ? "pb-2 border-b border-[#983D4A]" : ""}`}>
                <Link
                  className="w-full flex items-center py-2 gap-2"
                  to={route?.path}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!route?.isDropdown) {
                      navigate(route?.path);
                      setOpenDropdown(null);
                    }
                    toggleDropdown(route?.path)
                    closeModal();
                    localStorage.setItem("searchTexts", JSON.stringify({}));
                  }}
                >
                  <img
                    src={route?.icon}
                    className={`transition-all duration-300 ease-in-out group-hover:invert
                    ${pathname === route.path ||
                        //Added Conditions For Specific Route Path Active Icon Show in Sidebar
                        (route.path.includes("dashboard") && /^\/restaurantPanel\/dashboard(\/.*)?$/.test(pathname)) ||
                        (route.path.includes("viewStock") && /^\/restaurantPanel\/(viewStock|decreaseStock)(\/.*)?$/.test(pathname)) ||
                        (route.path.includes("incomingOrder") && /^\/restaurantPanel\/(incomingOrder|pastOrder)(\/.*)?$/.test(pathname)) ||
                        (route.path.includes("restaurant-user") && /^\/restaurantPanel\/(restaurant-user|restaurant-user-add)(\/.*)?$/.test(pathname)) ||
                        (route.path.includes("restaurantManagement") && /^\/restaurantPanel\/restaurantManagement(\/.*)?$/.test(pathname)) ||
                        (route.path.includes("menuManagement") && /^\/restaurantPanel\/(menuManagement|wineFood|dishManagement|beverageManagement|courseManagement|categoryManagement)(\/.*)?$/.test(pathname)) ||
                        (route.path.includes("userRole") && /^\/restaurantPanel\/userRole(\/.*)?$/.test(pathname)) ||
                        (route.path.includes("settings") && /^\/restaurantPanel\/settings(\/.*)?$/.test(pathname))
                        ? "invert"
                        : ""
                      }`}
                    height={15}
                    width={15}
                  />
                  <span>{route?.label}</span>
                </Link>
                {route?.isDropdown && <IoIosArrowForward onClick={() => toggleDropdown(route?.path)} className={`w-5 h-4 rounded-full ml-auto transition-transform transform duration-200 ${openDropdown === route.path ? "transform rotate-90" : ""}`} />}
              </div>
              {route?.isDropdown && openDropdown === route?.path && route?.dropdownContent}
            </div>
          ))}
        </nav>

        {localStorage.getItem('Role') === 'admin' &&
          <div className="overflow-visible w-[100%] my-2 items-center text-xs font-normal poppins-regular rounded-3xl group text-[#8B2433] bg-[#f7eeef] hover:text-white hover:bg-[#8b2532]">
            <Link
              className={`mt-auto py-2 px-3 gap-2 font-normal text-red-700 text-xs rounded-2xl flex items-center  ${pathname === (/^\/restaurantPanel\/logout\/.+/.test(pathname))
                ? "text-white bg-[#8a2533]"
                : "text-black-700 bg-[#f7eeef] hover:text-white hover:bg-[#8b2532]"
                }`}
              onClick={() => {
                redirectToAdmin()
              }}
            >
              <CgLogOut className="text-lg" />
              Back To Admin
            </Link>
          </div>
        }

        {localStorage.getItem('Role') === 'restaurant' &&
          <>
            <div className="w-[100%] mt-2 items-center text-xs font-normal poppins-regular rounded-3xl group text-[#8B2433] bg-[#f7eeef] hover:text-white hover:bg-[#8b2532]">
              <Link
                className={`mt-auto py-2 px-3 gap-2 font-normal text-red-700 text-xs rounded-2xl flex items-center  ${pathname === (/^\/restaurantPanel\/logout\/.+/.test(pathname))
                  ? "text-white bg-[#8a2533]"
                  : "text-black-700 bg-[#f7eeef] hover:text-white hover:bg-[#8b2532]"
                  }`}
                onClick={() => userLogout()}
              >
                <TbLogout2 className="text-lg" />
                Log Out
              </Link>
            </div>
            {settingsItems?.map((route, index) => route?.isPermission && (
              <div
                key={index}
                className={`w-[100%] py-1 px-4 items-center text-xs font-normal poppins-regular rounded-3xl my-2 group 
                    ${pathname === route?.path || (route.path.includes("settings") && /^\/restaurantPanel\/(settings|settingsDetail|changePassword)(\/.*)?$/.test(pathname))
                    ? "text-[#FFFFFF] bg-[#8B2433]"
                    : "text-[#8B2433] bg-[#f7eeef] border-[1.5px] border-[#8B243385] hover:text-white hover:bg-[#8b2532]"
                  }`}
              >
                <div className={`flex items-center cursor-pointer ${route?.isDropdown && openDropdown === route?.path ? "pb-2 border-b border-[#983D4A]" : ""}`}>
                  <Link
                    className="w-full flex items-center justify-start gap-x-2 py-1"
                    to={route?.path}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!route?.isDropdown) {
                        navigate(route?.path);
                        setOpenDropdown(null);
                      }
                      closeModal();
                    }}
                  >
                    <img
                      src={route?.icon}
                      className={`transition-all duration-300 ease-in-out group-hover:invert 
                       ${pathname === route?.path || (route.path.includes("settings") && /^\/restaurantPanel\/(settings|settingsDetail|changePassword)(\/.*)?$/.test(pathname))
                          ? "invert"
                          : ""
                        }`}
                      height={15}
                      width={15}
                    />
                    <span>{route?.label}</span>
                  </Link>
                  {route?.isDropdown && <IoIosArrowForward onClick={() => toggleDropdown(route?.path)} className={`w-5 h-4 rounded-full ml-auto transition-transform transform duration-200 ${openDropdown === route.path ? "transform rotate-90" : ""}`} />}
                </div>
                {route?.isDropdown && openDropdown === route?.path && route?.dropdownContent}
              </div>
            ))}
          </>
        }
      </div>
    </>
  );
});

// Define PropTypes
RestSidebar.propTypes = {
  closeModal: PropTypes.func,
  showSidebarForMobile: PropTypes.bool,
  setShowSidebarForMobile: PropTypes.func,
  hasPermission: PropTypes.func,
};

export default forwardRef(RestSidebar);